
export const validationRules = {
  btn_action: 'required|in:save,submit',

  name_bng: 'max:90|bangla|no_number',
  name_bng_submit: 'required|max:90|bangla|no_number',

  blood_group: 'max:5',
  blood_group_submit: 'required|max:5',

  religion: 'max:15',
  religion_submit: 'required|max:15',

  nid_brno: 'nid_brno|integer',
  nid_brno_submit: 'required|nid_brno|integer',

  is_married: 'integer',
  is_married_submit: 'required|integer',

  guardian_income_number: 'integer|max:10',
  guardian_income_number_submit: 'required|integer|max:10',


  guardian_income_word: 'max:150',
  guardian_income_word_submit: 'required|max:150',

  self_residence: 'integer',
  self_residence_submit: 'required|integer',

  residence_address: 'max:255|english_numbers',
  residence_address_submit: 'required|max:255|english_numbers',
  
  residence_mobile: 'mobile',
  residence_mobile_submit: 'required|mobile',


  spouse_name: 'max:90 |english',
  spouse_name_submit: 'required|max:90|english',
  
  spouse_mobile: 'mobile',
  spouse_mobile_submit: 'required|mobile',

  spouse_address: 'max:200 |english_numbers',
  spouse_address_submit: 'required|max:200 |english_numbers',

  fname_bng: 'max:90|bangla|no_number',
  fname_bng_submit: 'required|max:90|bangla|no_number',

  foccupation: 'max:50|english',
  foccupation_submit: 'required|max:50|english',

  fdesignation: 'max:50|english',
  fdesignation_submit: 'required|max:50|english',

  femployer_info: 'max:255|english_numbers',
  femployer_info_submit: 'max:255|english_numbers',
  
  fnid_brno: 'nid_brno|integer',
  fnid_brno_submit: 'required|nid_brno|integer',

  mname_bng: 'max:90|bangla|no_number',
  mname_bng_submit: 'required|max:90|bangla|no_number',

  mnid_brno: 'nid_brno|integer',
  mnid_brno_submit: 'required|nid_brno|integer',

  fmobile: 'mobile',
  fmobile_submit: 'required|mobile',

  mmobile: 'mobile',
  mmobile_submit: 'required|mobile',

  both_address_same: 'integer',
  both_address_same_submit: 'required|integer',

  present_house: 'max:150|english_numbers',
  present_house_submit: 'required|max:150|english_numbers',
  present_village: 'max:150|english_numbers',
  present_village_submit: 'required|max:150|english_numbers',
  present_poffice: 'max:50',
  present_poffice_submit: 'required|max:50',
  present_thana: 'max:50',
  present_thana_submit: 'required|max:50',
  present_district: 'max:50',
  present_district_submit: 'required|max:50',
  present_mobile: 'mobile',
  present_mobile_submit: 'required|mobile',

  permanent_house: 'max:150|english_numbers',
  permanent_house_submit: 'required|max:150|english_numbers',
  permanent_village: 'max:150|english_numbers',
  permanent_village_submit: 'required|max:150|english_numbers',
  permanent_poffice: 'max:50',
  permanent_poffice_submit: 'required|max:50',
  permanent_thana: 'max:50',
  permanent_thana_submit: 'required|max:50',
  permanent_district: 'max:50',
  permanent_district_submit: 'required|max:50',
  permanent_mobile: 'mobile',
  permanent_mobile_submit: 'required|mobile',

  guardian_name: 'max:90|english',
  guardian_name_submit: 'required|max:90|english',
  guardian_relation: 'max:15|english',
  guardian_relation_submit: 'required|max:15|english',
  guardian_mobile: 'mobile',
  guardian_mobile_submit: 'required|mobile',
  guardian_nid_brno: 'nid_brno|integer',
  guardian_nid_brno_submit: 'required|nid_brno|integer',
  guardian_address: 'max:200|english_numbers',
  guardian_address_submit: 'required|max:200|english_numbers',

  ssc_institute: 'max:150|english',
  ssc_institute_submit: 'required|max:150|english',
  ssc_center: 'max:6|integer',
  ssc_center_submit: 'required|max:6|integer',
  hsc_institute: 'max:150|english',
  hsc_institute_submit: 'required|max:150|english',
  hsc_center: 'max:6|integer',
  hsc_center_submit: 'required|max:6|integer',

  is_employee: 'integer',
  is_employee_submit: 'required|integer',
  job_description: 'max:50|english',
  job_description_submit: 'required|max:50|english',
  employer_details: 'max:150|english_numbers',
  employer_details_submit: 'required|max:150|english_numbers',
  employer_address: 'max:255|english_numbers',
  employer_address_submit: 'required|max:255|english_numbers',

  is_admitted: 'integer',
  is_admitted_submit: 'required|integer',
  admitted_course: 'max:40|english',
  admitted_course_submit: 'required|max:40|english',
  admitted_session: 'max:10|year_session',
  admitted_session_submit: 'required|max:10|year_session',
  admitted_subject: 'max:200|english',
  admitted_subject_submit: 'required|max:200|english',
  admitted_institute: 'max:150|english',
  admitted_institute_submit: 'required|max:150|english',
  admitted_regino: 'integer|max:20',
  admitted_regino_submit: 'required|integer|max:20',
  admitted_classroll: 'integer|max:10',
  admitted_classroll_submit: 'required|integer|max:10',

  is_postponed: 'integer',
  is_postponed_submit: 'required|integer',
  postponed_reason: 'max:255|english_numbers',
  postponed_reason_submit: 'required|max:255|english_numbers',
  is_expeled: 'integer',
  is_expeled_submit: 'required|integer',
  expeled_reason: 'max:255|english_numbers',
  expeled_reason_submit: 'required|max:255|english_numbers',
  expeled_period: 'max:10|integer',
  expeled_period_submit: 'required|max:10|integer',
  expeled_institute: 'max:150|english',
  expeled_institute_submit: 'required|max:150|english',
  expeled_examinfo: 'max:255|english_numbers',
  expeled_examinfo_submit: 'required|max:255|english_numbers',
  expeled_examinfo: 'max:255|english_numbers',
  is_readmitted: 'integer',
  is_readmitted_submit: 'required|integer',
  readmission_reason: 'max:255|english_numbers',
  readmission_reason_submit: 'required|max:255|english_numbers',


};
